import { createTheme } from '@mui/material/styles';

// Global MUI typography:
// - Base: Urbanist (matches your global body font)
// - Headings (h1–h6): Poppins
const theme = createTheme({
  spacing: 8,
  typography: {
    fontFamily: 'Urbanist, Arial, sans-serif',
    h1: { fontFamily: 'Poppins, Arial, sans-serif' },
    h2: { fontFamily: 'Poppins, Arial, sans-serif' },
    h3: { fontFamily: 'Poppins, Arial, sans-serif' },
    h4: { fontFamily: 'Poppins, Arial, sans-serif' },
    h5: { fontFamily: 'Poppins, Arial, sans-serif' },
    h6: { fontFamily: 'Poppins, Arial, sans-serif' },
  },
});

export default theme;

